<button class="marv_button" 
    [type]="this.typeButton" 
    [class.text_only]="this.iconButton === '' && !this.isFetching"
    [class.icon_only]="this.labelButton === ''"
    [class.rounded]="this.roundedButton"
    [class.disabled]="this.disabledButton || this.isFetching"
    [class.hide_phone]="this.hideLabelDevice === 'phone'"
    [class.hide_tablet]="this.hideLabelDevice === 'tablet'"
    [class.with_margin]="this.withMargin"
    [class.big]="this.sizeButton === 'big'"
    [class.small]="this.sizeButton === 'small'"
    [class.secondary]="this.colorButton === 'secondary'"
    [class.blue]="this.colorButton === 'blue'"
    [class.red]="this.colorButton === 'red'"
    [class.green]="this.colorButton === 'green'"
    [class.orange]="this.colorButton === 'orange'"
    [class.purple]="this.colorButton === 'purple'"
    [class.marvesting]="this.colorButton === 'marvesting'"
    [disabled]="this.disabledButton || this.isFetching"
    >    
    @if(this.isFetching){
        <ion-spinner></ion-spinner>
    }
    @else{
        @if(this.iconButton !== ''){
            <ion-icon [name]="this.iconButton"></ion-icon>
        }
    }
    @if(this.labelButton !== ''){
        <div class="marv_button_label">{{this.labelButton}}</div>
    }    
</button>